<!-- eslint-disable -->
<template>
	<el-container>
		<el-row class="list-container">
			<el-col :span="24">
				<el-button @click="refreshData" type="primary" size="small" icon="iconfont icon-shuaxin shuaxin">刷新</el-button>
				<el-button type="primary" size="small" icon="iconfont icon-jia shuaxin" @click="editTmp(form)" :disabled="!power.manage_add">新增</el-button>
				<el-button @click="delMultiple" type="danger" size="small" icon="iconfont icon-shanchu shuaxin" :disabled="!power.manage_del">删除</el-button>
			</el-col>
			<el-col :span="24" class="search-content">
				<div class="search-item" style="width: 100px;">
					<el-select v-model="data.status" placeholder="请选择" size="small">
						<el-option
						  v-for="item in options"
						  :key="item.value"
						  :label="item.label"
						  :value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="search-item">
					<el-input v-model="data.name" size="small" placeholder="请输入姓名" clearable></el-input>
				</div>
				<div class="search-item">
					<el-button size="small" icon="iconfont icon-fangdajing shuaxin" @click="search">搜索</el-button>
				</div>
			</el-col>
			<el-col class="main-content">
				<el-table :data="dataList" border @selection-change="handleSelectionChange" v-loading="loading" style="width: 100%">
					<el-table-column type="selection" width="40"></el-table-column>
					<el-table-column prop="id" label="ID" width="70"></el-table-column>
					<el-table-column prop="name" label="姓名" width="150"></el-table-column>
					<el-table-column prop="username" label="账号" width="180"></el-table-column>
					<el-table-column prop="roles_name" label="角色" width="120"></el-table-column>
          <el-table-column label="状态" width="70">
          	<template slot-scope="scope">
              <el-switch
                :disabled="scope.row.id == 1 || !power.manage_add"
                v-model="status = scope.row.status"
                @change="switchChange"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="2">
              </el-switch>
          	</template>
          </el-table-column>
					<el-table-column prop="login_time" label="登陆时间" width="170"></el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button @click="editTmp(scope.row)" icon="iconfont icon-bianji shuaxin" type="primary" size="mini" plain :disabled="!power.manage_add">编辑</el-button>
							<el-button v-if="scope.row.id != 1" @click="del(scope.row.id)" icon="iconfont icon-shanchu shuaxin" size="mini" type="danger" plain :disabled="!power.manage_del">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
			<el-col class="pagination">
				<el-pagination
					@current-change="changePage"
				  @size-change="changePageSize"
					background
				  :layout="pageLayout"
				  :page-sizes="pagePageSizes"
				  :page-size="pagePageSize"
					:total="totalCount"
				  :current-page.sync="current_page"
					:hide-on-single-page="false">
				</el-pagination>
			</el-col>
		</el-row>

		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" @close="dialogClose" width="550px" :close-on-click-modal="false" center>
		  <el-form :model="form" ref="form" :rules="rules" class="dialog-form">
			<el-form-item label="姓名" :label-width="formLabelWidth"
			prop="name">
			  <el-input v-model="form.name" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="账号" :label-width="formLabelWidth"
			prop="username">
			  <el-input v-model="form.username" autocomplete="off"></el-input>
			</el-form-item>

			<el-form-item v-if="form.id > 0" label="密码" :label-width="formLabelWidth"
			prop="password"
			:rules="{ validator: this.checkPassword, trigger: 'blur' }">
			  <el-input v-model="form.password" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item v-else label="密码" :label-width="formLabelWidth"
			prop="password"
			:rules="[
				{ required: true, message: '请输入密码', trigger: 'blur' },
				{ validator: this.checkPassword, trigger: 'blur' }
				]">
			  <el-input v-model="form.password" autocomplete="off"></el-input>
			</el-form-item>

      <el-form-item label="角色"
          :label-width="formLabelWidth"
          prop="roles_id"
          :rules="[
          { required: true, message: '请选择角色', trigger: 'blur' }
          ]">
          <el-select v-model="form.roles_id" placeholder="请选择角色">
              <el-option
                  v-for="item in roles"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
          </el-select>
      </el-form-item>

			<el-form-item label="状态" :label-width="formLabelWidth"
			prop="status"
			:rules="{ required: true, message: '请选择状态', trigger: 'blur' }">
				<el-radio v-model="form.status" label="1" border>正常</el-radio>
				<el-radio v-model="form.status" label="2" border>禁用</el-radio>
			</el-form-item>

		  </el-form>
		  <div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="addData('form')" :loading="loadingAdd">确 定</el-button>
		  </div>
		</el-dialog>
	</el-container>
</template>

<!-- eslint-disable -->
<script>
	import {ManageIndex, ManageAdd, ManageDel} from '@/utils/request.js'
  import {mapState} from 'vuex'

	export default {
		data(){
			return {
				dialogTitle: '新增管理员',
				data: {
					page: 1,
          page_size: this.pagePageSize,
					name: '',
					status: '0'
				},
				options: [{
				  value: '0',
				  label: '所有状态'
				}, {
				  value: '1',
				  label: '正常'
				}, {
				  value: '2',
				  label: '禁用'
				}],
				dataList: [{
					id: 0,
					name: 'name',
					status: '1',
					username: 'username',
					created_at: 'created_at',
					login_time: 'login_time',
					login_num: 'login_num',
          roles_name: ''
				}],
        roles: [],
				dialogFormVisible: false,
				formLabelWidth: '120px',
				form: {
					id: 0,
					name: '',
					status: '1',
					username: '',
					password: '',
          roles_id: ''
				},
				multipleSelection: [],
				loading: false,
				loadingAdd: false,
				totalCount: 0,
        current_page: 1,
        status: null,
				rules: {
					name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
					],
					username: [
						{ required: true, message: '请输入账号', trigger: 'blur' }
					]
				}
			}
		},
		created() {
			this.getList()
		},
    computed: mapState(['power']),
		methods: {
			checkPassword (rule, value, callback) {
				if (this.form.id > 0) {
					// 编辑
					if (value && value.length < 6) {
						return callback(new Error('密码不能小于6位数'));
					}
				} else {
					// 新增
					if (value.length < 6) {
						return callback(new Error('密码不能小于6位数'));
					}
				}
				callback();
			},
			search() {
				this.data.page = 1
        this.current_page = 1
				this.getList()
			},
			refreshData() {
				this.data.page = 1
        this.current_page = 1
				this.getList()
			},
			handleSelectionChange(val) {
				this.multipleSelection = []
				if (val.length > 0) {
					val.filter((item) => {
						this.multipleSelection.push(item.id)
					})
				}
			},
			delMultiple() {
				if (this.multipleSelection.length == 0) {
					this.$message.error('请至少选择一项你要删除的项');
					return
				}
				this.del(this.multipleSelection)
			},
			del(id) {
				this.$confirm('确定要执行删除操作吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'error'
				}).then(() => {
					ManageDel({id: id}).then((res) => {
						if (res.code == 200) {
							this.data.page--
							this.getList()
							this.$message.success(res.msg);
						} else {
							this.$message.error(res.msg);
						}
					})
				}).catch(() => {
					// 取消操作
				});
			},
			changePage(page) {
				this.data.page = page
				this.getList()
			},
      changePageSize(size) {
      	this.data.page_size = size
        this.data.page = 1
        this.current_page = 1
      	this.getList()
      },
			dialogClose() {
				this.initForm()
			},
			editTmp(data) {
				this.form = {
					id: data.id,
					name: data.name,
					status: data.status.toString(),
					username: data.username,
					roles_id: data.roles_id,
					password: ''
				}
				this.dialogTitle = this.form.id > 0 ? '编辑管理员' : '新增管理员'
				this.dialogFormVisible = true
			},
			getList() {
				this.loading = true
				ManageIndex(this.data).then((res) => {
					if (res.code == 200) {
						this.data.page++
						this.dataList = res.data.data
						this.totalCount = res.data.count
            this.roles = res.data.roles
					} else {
						this.$message.error('数据获取失败!')
					}
					this.loading = false
				})
			},
			addData(formName) {
				this.$refs[formName].validate((valid) => {
				  if (valid) {
					this.loadingAdd = true
					ManageAdd(this.form).then((res) => {
						if (res.code == 200) {
							this.$message.success(res.msg);
							this.dialogFormVisible = false
							this.data.page--
							this.getList()
						} else {
							this.$message.error(res.msg);
						}
						this.loadingAdd = false
					})
				  }
				});
			},
			initForm() {
				// 初始化，form数据
				this.form = {
					id: 0,
					name: '',
					status: '1',
					username: '',
					password: '',
          roles_id: ''
				}
				// 重置字段验证
				this.$refs['form'].resetFields();
			},
      switchChange(value) {
        ManageAdd({id: this.status.id, status: value, ac: 'status'}).then((res) => {
            if (res.code == 200) {
                this.$message.success(res.msg);
            } else {
                this.$message.error(res.msg);
            }
        })
      }
		}
	}
</script>

<style>
</style>
